const importRun = {
  run: null,
  batches: []
}

export default () => Object.assign({}, importRun, { batches: [] })
